import { EventEmitter } from '@angular/core';

export const listener_SEARCHBOX: EventEmitter<{key:String, text:String}> = new EventEmitter<{key:String, text:String}>();